export const NOT_ACTIVATED = 'web-playground.activation-required';

export const BACKEND_ERROR_MESSAGES = {
	258: NOT_ACTIVATED,
	2: NOT_ACTIVATED,
	257: 'web-playground.more-xp-needed',
};
